// @flow

import * as components from './components';
import * as lazyComponents from './components.lazy';
import { exposeComponents, exposeLazyComponents } from 'boot/common/reactMount';

exposeComponents(components);
exposeLazyComponents(lazyComponents);
